import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import kitService from "@/services/kit.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveKitReturn = {
  removeKit: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveKit = (): UseRemoveKitReturn => {
  const {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove: removeKit,
  } = useRemove({
    operation: (kitId) => kitService.delete(kitId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    removeKit,
  };
};

export default useRemoveKit;
